export default __webpack_public_path__ + "static/media/logo-rtl-dark.6f5b7931.svg";